<template>
  <div id="game-layout">
    <Suspense>
      <main>
        <router-view v-slot="{ Component, route }">
          <transition mode="out-in" name="fade">
            <div :key="route.name">
              <component :is="Component" :id="route.name" />
            </div>
          </transition>
        </router-view>
      </main>
    </Suspense>
  </div>
</template>

<script setup>
import { useDark, useToggle } from "@vueuse/core";
import { useCandidateStore } from "@/stores/candidate.js";
import { onMounted, watch, inject } from "vue";

const isDark = useDark();

const toggleDark = useToggle(isDark);

if (!isDark.value) toggleDark();

const crisp = inject("crisp");

const { candidate } = useCandidateStore();

watch(candidate, () => {
  if (candidate.candidate_id) {
    crisp.user.setEmail(candidate.email);
    crisp.user.setNickname(`${candidate.first_name} ${candidate.last_name}`);
    crisp.session.setData({
      user_id: candidate.candidate_id,
    });
  }
});

onMounted(async () => {
  crisp.session.setSegments(["Candidat"]);
});
</script>
